import { toast, ToastOptions, Id } from 'react-toastify';

const customId = "custom-id-yes";
const notificationToastId = "notification-toast-id";
const options: ToastOptions = {
  hideProgressBar: true,
  position: 'bottom-center',
  autoClose: 3000,
  closeOnClick: true,
  draggable: false,
  toastId: customId,
};
// Keep track of active toast and audio
let activeToastId: Id | null = null;
let notificationAudio: HTMLAudioElement | null = null;

const optionsNotification: ToastOptions = {
  hideProgressBar: true,
  position: 'top-right',
  autoClose: false, // do not auto close
  closeOnClick: true,
  draggable: false,
  onClose: () => {
    // stop audio when toast is manually closed
    if (notificationAudio) {
      notificationAudio.pause();
      notificationAudio.currentTime = 0;
      notificationAudio = null;
    }
    activeToastId = null;
  },
};
const optionsInfo: ToastOptions = {
  type: 'info',
  ...options
};
const optionsSuccess: ToastOptions = {
  type: 'success',
  ...options
};
const optionsError: ToastOptions = {
  type: 'error',
  ...options
};


function canBeRendered(content: any) {
  return typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
};

export const ToastNotifyInfo = (message: string) => { canBeRendered(message) && toast(message, optionsInfo) }
export const ToastNotifySuccess = (message: string) => { canBeRendered(message) && toast(message, optionsSuccess) }
export const ToastNotifyError = (message: string) => { !toast.isActive(customId) && canBeRendered(message) && toast(message, optionsError) }

export const ToastNotifyNotification = (message: string) => {
  if (!canBeRendered(message)) return;

  // Dismiss any existing notification first (keep only the latest)
  if (activeToastId) {
    toast.dismiss(activeToastId);
  }

  // Play looping sound
  notificationAudio = new Audio('/notification.mp3');
  notificationAudio.loop = true;
  notificationAudio.play().catch(() => {
    console.warn('User interaction required before playing sound.');
  });

  // Show the toast
  activeToastId = toast(message, optionsNotification);
};